(function($){


    function tailwind() {
        const $head = document.head || document.querySelector('head');
        const $link = document.createElement('link');
        const url = window.tailwind_stylesheet || 'https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css';


        $link.rel = 'stylesheet';
        $link.href = url;

        $link.onload = function() {
            
            if(!window.SwymCallbacks){
                window.SwymCallbacks = [];
            }
            // window.SwymCallbacks.push(startWishlist);
        }

        $head.appendChild($link);
    }

    function buildItem(item) { 
        const $item = document.createElement('div');

        $item.classList += 'w-1/2 md:w-1/3 lg:w-1/4';

        $item.innerHTML = `
            <div class="item-wrapper w-full pb-10 group">
              <a href="${item.du}" class="w-full flex flex-col px-3 text-center">
                <img src="${item.iu}">
                <p class="mt-2 text-center wishlist-item__title">${item.dt}</p>    
                <p class="mt-2 text-center wishlist-item__price" id="price-${item.id}"></p>          
              </a>
              <button type="button" data-remove="remove" data-id="${item.id}" class="opacity-0 group-hover:opacity-100 w-full text-center text-lg">Remove</button>
            </div>
        `;

        $item.querySelector('button[data-remove="remove"]').addEventListener('click', function(e) {
            const $btn = e.target;
            const id = $btn.getAttribute('data-id');
            const item = [...window.wishlist_currents].find((i) => i.id === id);

            window._swat.removeFromWishList({
                ...item
            }, function() {
                $item.parentElement.removeChild($item);
            });
        });

        return $item;
    }

    function buildShareBar() {
        const $wrapper = document.getElementById('wishlist-share');
        $wrapper.innerHTML = `
            <span class="share-label">Share:</span>
            <button type="button" data-share="link" class="wishlist-share-btn">
              <img src="${window.image_assets.link_icon}" alt="Generate Share Link" />
            </button>
            <button type="button" data-share="fb" class="wishlist-share-btn">
              <img src="${window.image_assets.facebook_like_icon}" alt="Generate Share Facebook Link" />
            </button>
            <p id="share-url"></p>
        `;

        function copyTextToClipboard(text) {
            if (!navigator.clipboard) {
              return text;
            }
            return navigator.clipboard.writeText(text).then(function() {
              console.log('Async: Copying to clipboard was successful!');

              return 'Link successfully copied!';
            }, function(err) {
              console.error('Async: Could not copy text: ', err);

              return text;
            });
        }


        $wrapper.querySelector('[data-share="link"]').addEventListener('click', function(even) {
            window._swat.generateSharedWishlistURL(
                null,
                async function(data) { 
                    const url = data; 
                    console.log('Url', data); 
                    const message = await copyTextToClipboard(url);
                    document.querySelector('#share-url').textContent = message;

                },     // returns the generated url
                function(data) { console.log('Url Pt2', data); }
            );
        });


        $wrapper.querySelector('[data-share="fb"]').addEventListener('click', function(even) {
            window._swat.shareListSocial(
                null,
                '',
                "https://www.facebook.com/sharer.php?u={{shareurl}}&t={{note}}",
                "facebook",
                "",
                async function(data) { 
                    const url = data; 
                    console.log('Url', data); 
                    const message = await copyTextToClipboard(url);
                    document.querySelector('#share-url').textContent = message;
                }
              ); // will open facebook share dialog
        });
    }

    async function startWishlist(items) {
        const $wrapper = document.querySelector('#wishlist-wrapper');
        const $list = document.querySelector('#wishlist-items')
        // const items = await new Promise((resolve, reject) => {
        //     window._swat.fetchWrtEventTypeET(
        //         function(r) {
        //             console.log('Wishlist Page Response', r);
        //           // Get wishlist items
        //           if(r) resolve(r)
        //           else reject(r);
        //         },
        //         window._swat.EventTypes.addToWishList
        //     );
        // });

        window.wishlist_currents = [...items];
        const $items = items.map(buildItem);

        buildShareBar();
        [...$items].forEach(($item) => {
            $list.appendChild($item);
        });
        

        console.log('Wishlist Items', items);

        $wrapper.style.opacity = '1';
        const currency = document.body.getAttribute('data-currency-symbol') || '$';

        for(let i = 0; i < items.length; i++) {
            let item = items[i];
            let url = item.du;

            let data = await fetch(`${url}.js`).then((res) => res.json())

            let price = Shopify.formatMoney(data.price, `${currency}{{amount_no_decimals}}`);
            let $price = document.querySelector(`#price-${item.id}`);

            $price.textContent = price;
        }
    }

    window.buildWishlistPage = startWishlist;

    tailwind();
    console.log('Wishlist Page!');
})(window.$ || window.jQuery)